import { Checkbox, Form } from 'antd';
import { StoreScopesModal } from 'components/StoreScopes';
import { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import ScopePreviewModal from '../components/ScopePreviewModal';
import ScopeTag from '../components/ScopeTag';

export interface RolePermScopeTypeProps {
  departmentId: number;
  departmentScopes?: General.StoreScope[];
  disabled?: boolean;
}

function RolePermScopeType(props: RolePermScopeTypeProps) {
  const { departmentId, departmentScopes, disabled = false } = props;

  const { t } = useTranslate();

  const [visible, setVisible] = useState(false);

  return (
    <Form.Item
      required
      dependencies={['allScopes, rolePermScopeType']}
      label={t('department.选择角色负责的店铺范围')}
    >
      {({ getFieldValue, setFieldsValue }) => {
        const rolePermScopeType = getFieldValue('rolePermScopeType');

        const allScopes = getFieldValue('allScopes') || [];

        return (
          <div>
            <div className="mb-2">
              <ScopeTag
                value={allScopes}
                departmentScopes={departmentScopes}
                disabled={disabled}
                onClick={() => setVisible(true)}
                onClear={() => setFieldsValue({ allScopes: [] })}
              />
            </div>
            <Checkbox
              disabled={disabled}
              checked={rolePermScopeType === 'ALL_PERM_ALIGNED'}
              onChange={({ target: { checked } }) => {
                setFieldsValue({
                  rolePermScopeType: checked ? 'ALL_PERM_ALIGNED' : 'DIFF_BY_PERM',
                });
              }}
            >
              {t('department.各项权限的店铺范围保持一致')}
            </Checkbox>
            {disabled ? (
              <ScopePreviewModal
                value={allScopes}
                visible={visible}
                onCancel={() => setVisible(false)}
              />
            ) : (
              <StoreScopesModal
                showFooterTips={false}
                departmentId={departmentId}
                visible={visible}
                onCancel={() => setVisible(false)}
                value={allScopes}
                onChange={(allScopes) => setFieldsValue({ allScopes })}
              />
            )}
          </div>
        );
      }}
    </Form.Item>
  );
}

export default RolePermScopeType;
